import { Component, EventEmitter, OnInit, Output } from '@angular/core';

@Component({
  standalone: false,
  selector: 'app-language-selector-modal',
  templateUrl: './language-selector.component.html',
  styleUrls: ['../modal.component.scss'],
})
export class LanguageSelectorModalComponent implements OnInit {
  languages: Array<{ value: string; label: string }> = [
    { value: 'ser', label: 'Srpski' },
    { value: 'en', label: 'Engleski' },
  ];
  selectedLanguage: string;
  @Output() readonly responseChanged = new EventEmitter();

  ngOnInit(): void {
    this.selectedLanguage = this.languages[0].value;
  }

  emitFalse(): void {
    this.responseChanged.emit(false);
  }

  emitTrue(): void {
    this.responseChanged.emit(this.selectedLanguage);
  }
}
